import React, { useEffect, useState } from 'react';
import _path from 'ramda/src/path';
import Image from '../Image';
import ClientStorage from '../ClientStorage';
import userTasks from './userTasks';
import { MIXPANEL_CONTENT, MIXPANEL_DELETE } from '../../../Constants';
import Mixpanel from '../../../API/Mixpanel';

const UserTaskWidget = () => {
    const [task, setTask] = useState(null);
    const [isCompleted, setIsCompleted] = useState(false);
    const [completedTasks, setCompletedTasks] = useState([]);
    const [lastCompletedTaskTime, setLastCompletedTaskTime] = useState(null);

    // just show for no experience or RESAAS experience
    if (_path(['Environment', 'Experience'], RESAAS) && _path(['Environment', 'Experience'], RESAAS) !== "resaas" && _path(['Environment', 'Experience'], RESAAS) !== "commercial") {
        return true;
    }


    const showNewTask = time => {
        // current timestamp
        const currentTimestamp = Date.now();

        // lastCompletedTaskTime
        const taskCompletedTimestamp = time;

        // the next 12-hour timestamp
        const twelveHoursInMillis = 12 * 60 * 60 * 1000;
        const next12HourTimestamp = taskCompletedTimestamp + twelveHoursInMillis;
        return currentTimestamp >= next12HourTimestamp;
    };

    const randomTask = incompletedTasks => {
        const taskIndex = Math.floor(Math.random() * incompletedTasks.length);
        return incompletedTasks[taskIndex];
    };

    const renderIncompletedTask = task => {
        if (task) {
            setTask(task);
            sessionStorage.setItem('userTask', task.name);
        }
    };

    useEffect(() => {
        let clientStorage;

        if (
            !_path(['Environment', 'GateUserTasks'], RESAAS) 
            
        ) {
            let inCompletedTask;
            const userTaskSessionStorage = sessionStorage.getItem('userTask');
            const inCompletedTaskInSessionStorage = userTasks.find(task => task.name === userTaskSessionStorage);
            clientStorage = ClientStorage.get(['UserTasks'], true);
            clientStorage.promise
                .then(value => {
                    if (inCompletedTaskInSessionStorage) {
                        inCompletedTask = inCompletedTaskInSessionStorage;
                    } else if (value && value.UserTasks) {
                        const userTaskInfo = JSON.parse(value.UserTasks);
                        setCompletedTasks(userTaskInfo.completedTasks);
                        setLastCompletedTaskTime(userTaskInfo.lastCompletedTaskTime);
                        if (showNewTask(userTaskInfo.lastCompletedTaskTime)) {
                            const inCompletedTasks = userTasks.filter(
                                item =>
                                    !userTaskInfo.completedTasks.some(
                                        obj => obj.name === item.name && obj.done === true
                                    )
                            );

                            inCompletedTask = randomTask(inCompletedTasks);
                        }
                    } else {
                        inCompletedTask = randomTask(userTasks);
                    }
                    if (inCompletedTask) {
                        renderIncompletedTask(inCompletedTask);
                    }
                })
                .catch(error => {
                    if (error !== 'cancel') {
                        LogglyLogger.add(
                            LOGGLY_LEVEL_ERROR,
                            'WebRequestFailure: ClientStorage.get in TasksContainer.js',
                            error
                        );
                    }
                });
        }

        return () => {
            if (clientStorage) {
                clientStorage.cancel();
            }
        };
    }, []);

    const taskCompleted = () => {
        const newCompletedTask = { name: task.name, done: true };
        const newData = { lastCompletedTaskTime: Date.now() };
        newData.completedTasks = completedTasks.concat(newCompletedTask);

        ClientStorage.set('UserTasks', JSON.stringify(newData))
            .then(() => {
                Mixpanel.add(MIXPANEL_CONTENT, { content: 'usertask', context: task.name });
                setCompletedTasks(newData.completedTasks);
                setIsCompleted(true);
                sessionStorage.removeItem('userTask');
            })
            .catch(error => {
                LogglyLogger.add(LOGGLY_LEVEL_ERROR, `Set ${newData} as completed task is failed`, error);
            });
    };

    const undoTask = () => {
        sessionStorage.setItem('userTask', task.name);
        setIsCompleted(false);
        const undoTask = task.name;
        const newData = { lastCompletedTaskTime: lastCompletedTaskTime };
        newData.completedTasks = Object.assign(completedTasks).filter(task => task.name !== undoTask);
        setCompletedTasks(newData.completedTasks);
        ClientStorage.set('UserTasks', JSON.stringify(newData))
            .then(() => {
                Mixpanel.add(MIXPANEL_DELETE, { content: 'usertask', context: undoTask });
            })
            .catch(error => {
                LogglyLogger.add(LOGGLY_LEVEL_ERROR, `undo ${newData} is failed`, error);
            });
    };

    const handleTaskChange = e => {
        if (!isCompleted) {
            taskCompleted();
        } else {
            undoTask();
        }
    };

    return (
        <React.Fragment>
            {task ? (
                <aside
                    className={`re-container-outer re-container-md re-usertask-container re-feed-side-widget-mobile-hidden ${
                        isCompleted ? 're-usertask-done' : ''
                    }`}
                    data-taskname={task.name}
                    data-testid="usertask"
                >
                    <div className="re-container-header">Today's Task</div>
                    <div className="re-usertask-completed">
                        <Image
                            src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/31930593-2f97-4626-b6a6-bf64d37f8ce1.png"
                            width={78}
                            height={80}
                        />
                        <div className="re-usertask-completed-content">
                            <div className="re-usertask-completed-message">Congratulations</div>
                            <div className="re-usertask-completed-message" dangerouslySetInnerHTML={{ __html: task.successMessage }} />
                            <button onClick={undoTask} className="re-usertask-undo" data-testid="undotask">
                                Oops! I'm not done
                            </button>
                        </div>
                    </div>

                    <div className="re-usertask-content">
                        <Image
                            className="re-usertask-banner"
                            src={task.image}
                            alt={task.title}
                            width={241}
                            height={78}
                        />
                        <div className="re-usertask-title" dangerouslySetInnerHTML={{ __html: task.title }} />
                        <div className="re-usertask-desc" dangerouslySetInnerHTML={{ __html: task.description }} />
                        {task.cta ? (
                            <div className="re-usertask-cta">
                                <a
                                    target={task.newTab ? '_blank' : '_self'}
                                    href={task.cta}
                                    data-mixpanel-name="Intent"
                                    data-mixpanel-type="usertask-clicked"
                                    data-mixpanel-context={task.name}
                                    data-mixpanel-content="usertask"
                                >
                                    {task.ctaText}
                                </a>
                            </div>
                        ) : null}
                        <div className="re-usertask-checkbox">
                            <input
                                type="checkbox"
                                id="taskComplete"
                                name="taskComplete"
                                onChange={handleTaskChange}
                                checked={isCompleted}
                                data-testid="taskComplete"
                            />
                            <label htmlFor="taskComplete" className="re-usertask-checkbox-label">
                                Mark as completed
                            </label>
                        </div>
                    </div>
                </aside>
            ) : null}
        </React.Fragment>
    );
};

export default UserTaskWidget;
